var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 480,
    viewBox: "0 0 544 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 64,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 96,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 128,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 160,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 192,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 288,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 320,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 352,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 448,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 512,
    y: 256,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 448,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 480,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 384,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 416,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 224,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 192,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 224,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 256,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 320,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 352,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 384,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 116,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 116,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 148,
    width: 32,
    height: 32,
    fill: "#4284C0"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 61,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 64,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 64,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 192,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 224,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 256,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 320,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 384,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 384,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 416,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 352,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 96,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 61,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 93,
    width: 32,
    height: 32,
    fill: "#C3C5D6"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 116,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 148,
    width: 32,
    height: 32,
    fill: "#CB7632"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 171,
    width: 32,
    height: 32,
    fill: "#D584B1"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: 32,
    width: 32,
    height: 32,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtCat);
export default __webpack_public_path__ + "static/media/pixel-art-cat.aae581cf130762d36cdd3e603f7ab629.svg";
export { ForwardRef as ReactComponent };